import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Instructions from "../components/Instructions";

export default function PEInformativeEvent(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  const informativeTitle = (type) => {
    switch (type) {
      case 0: {
        return "Email";
      }
      case 1: {
        return "Voicemail";
      }
      case 2: {
        return "Note/Memo";
      }
      case 3: {
        return "Text Message/IM";
      }
      case 4: {
        return "NPC Interaction";
      }
    }
  };

  const senderTitle = (type) => {
    switch (type) {
      case 1:
        return "Caller";
      case 4:
        return "Speaker";
      default:
        return "Sender";
    }
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
        noInstructions
      />

      <Typography className="text-14 font-bold p-16 pb-0">
        {informativeTitle(data.core.type_id)}:
      </Typography>

      {/* <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={4} sm={2}>
            <Typography className="text-14 font-bold m-0">
              Instructions:
            </Typography>
          </Grid>
          <Grid item xs={8} sm={10}>
            <Typography className={`${tl} m-0`} dir={dir}>
              {data.core.instructions}
            </Typography>
          </Grid>
        </Grid>
      </Paper> */}

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={4} sm={2}>
            <Typography className="text-14 font-bold m-0">
              {senderTitle(data.core.type_id)}:
            </Typography>
          </Grid>
          <Grid item xs={8} sm={10}>
            <Typography className={data.core.tl ? `${tl} m-0` : "text-14 m-0"} dir={data.core.tl ? dir : "ltr"}>{data.core.sender}</Typography>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid item xs={12}>
          <Typography className="text-14 font-bold m-0">Content:</Typography>
          <Divider className="my-16" />
        </Grid>
        {(data.core.type_id === 0 || data.core.type_id === 2) && (
          <Grid container spacing={1} className="mb-16">
            <Grid item xs={4} sm={2}>
              <Typography className="text-14 font-semibold m-0">
                Subject:
              </Typography>
            </Grid>
            <Grid item xs={8} sm={10}>
              <Typography className={data.core.tl ? `${tl} m-0` : "text-14 m-0"} dir={data.core.tl ? dir : "ltr"}>
                {data.core.subject}
              </Typography>
            </Grid>
          </Grid>
        )}
        {(data.core.type_id === 0 ||
          data.core.type_id === 2 ||
          data.core.type_id === 3) && (
          <Grid container spacing={1} className="mb-16">
            <Grid item xs={4} sm={2}>
              <Typography className="text-14 font-semibold m-0">
                Body:
              </Typography>
            </Grid>
            <Grid item xs={8} sm={10}>
              <Typography
                className={data.core.tl ? `${tl} m-0` : "text-14 m-0"}
                dir={data.core.tl ? dir : "ltr"}
                dangerouslySetInnerHTML={{ __html: data.core.body }}
              />
            </Grid>
          </Grid>
        )}
        {data.core.type_id === 1 && (
          <Grid container spacing={1} className="mb-16">
            <Grid item xs={4} sm={2}>
              <Typography className="text-14 font-semibold m-0">
                Transcript:
              </Typography>
            </Grid>
            <Grid item xs={8} sm={10}>
              <Typography
                className={`${tl} m-0`}
                dir={dir}
                dangerouslySetInnerHTML={{ __html: data.core.transcript }}
              />
            </Grid>
          </Grid>
        )}
        {data.core.type_id === 4 && (
          <>
            <Grid container spacing={1} className="mb-16">
              <Grid item xs={4} sm={2}>
                <Typography className="text-14 font-semibold m-0">
                  Speaker description:
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography
                  className="text-14 m-0"
                  dangerouslySetInnerHTML={{ __html: data.core.sender_desc }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} className="mb-16">
              <Grid item xs={4} sm={2}>
                <Typography className="text-14 font-semibold m-0">
                  Statement:
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography
                  className={`${tl} m-0`}
                  dir={dir}
                  dangerouslySetInnerHTML={{ __html: data.core.statement }}
                />
              </Grid>
            </Grid>
          </>
        )}
        <Grid container spacing={1}>
          <Grid item xs={4} sm={2}>
            <Typography className="text-14 font-semibold m-0">
              Task Title:
            </Typography>
          </Grid>
          <Grid item xs={8} sm={10}>
            <Typography className="text-14 m-0">
              {data.core.task_title}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
